import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pass",
  "use": "icon-pass-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pass\"><path d=\"M884.992 224.32a44.8 44.8 0 0 1 0 63.36l-469.312 469.312a44.8 44.8 0 0 1-63.36 0L139.008 543.68a44.8 44.8 0 1 1 63.36-63.36L384 661.952l437.632-437.632a44.8 44.8 0 0 1 63.36 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol